$('.user-cvk-application-create').click( function(){
    Swal.fire({
        title: 'Ви дійсно бажаєте подати заявку?',
        text: "Якщо ви вже подавали заявку на голосування, то попередню заявку буде анульовано!",
        icon: 'warning',
        showDenyButton: true,
        confirmButtonText: `Так`,
        denyButtonText: `Ні`,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            $('#sendUserCVKApplication').submit();
        }
    })
});

$('.user-application-create').click( function(){
    Swal.fire({
        title: 'Ви дійсно бажаєте подати заявку?',
        text: "Якщо ви вже подавали заявку на голосування, то попередню заявку буде анульовано!",
        icon: 'warning',
        showDenyButton: true,
        confirmButtonText: `Так`,
        denyButtonText: `Ні`,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            $('#sendUserApplication').submit();
        }
    })
});